import { Button, Text } from '@chakra-ui/react';
import { useState } from 'react';

interface CollapsibleListProps<T> {
    items: T[];
    initialCount: number;
    renderItem?: (item: T) => string;
    separator?: string;
}

export const CollapsibleList = <T,>({
    items,
    initialCount,
    renderItem = (item) => String(item),
    separator = ', ',
}: CollapsibleListProps<T>) => {
    const [showAll, setShowAll] = useState(false);

    if (items.length === 0) {
        return null;
    }

    const hasMore = items.length > initialCount;
    const displayedItems = showAll ? items : items.slice(0, initialCount);

    return (
        <Text>
            {displayedItems.map(renderItem).join(separator)}
            {hasMore && !showAll && (
                <>
                    {' ... '}
                    <Button variant="link" size="sm" colorScheme="blue" onClick={() => setShowAll(true)}>
                        show {items.length - initialCount} more
                    </Button>
                </>
            )}
            {showAll && hasMore && (
                <>
                    {' '}
                    <Button variant="link" size="sm" colorScheme="blue" onClick={() => setShowAll(false)}>
                        show less
                    </Button>
                </>
            )}
        </Text>
    );
};
